import './Aside.css'
import { useNavigate } from 'react-router-dom';


function Aside() {
    const navigate = useNavigate();
    var height = 700;
    var width = 1000;
    var top = (window.outerHeight - height) / 2;
    var left = window.screen.availWidth + (window.screen.availWidth - width) / 2;
    const linkRadioCosmoSite = 'https://www.radiocosmo.it/';
    const linkRadioCosmoLive = 'https://www.inmystream.app/player2/radiocosmo.html';
    const linkRadioCosmoWatch = 'https://wz3.inmystream.it:2020/public/cosmoradio';
    const newPage = '';
    const newPageResized = 'location=yes,height=' + height + ',width=' + width + ',top=' + top + ',left=' + left + ',scrollbars=yes,status=yes';


    function openWindow(url: string, newPage: string) {
        window.open(
            url,
            "_blank",
            newPage
        );
    };

    return (
        <div className="aside-container">
            <div className='five-x-container'>
                <img className='logo-fit' src={process.env.PUBLIC_URL + '/5x1000.png'} alt="" />
            </div>
            <div className='radio-cosmo-container'>
                <div className='radio-cosmo-site'>
                    <img
                        className='logo-fit'
                        src={process.env.PUBLIC_URL + '/radio-cosmo-logo.png'}
                        alt=""
                        onClick={() => openWindow(linkRadioCosmoSite, newPage)}
                    />
                </div>
                <div id='radio-cosmo-live' onClick={() => openWindow(linkRadioCosmoLive, newPageResized)} >
                    <p>ASCOLTA RADIOCOSMO</p>
                </div>
                <div id='radio-cosmo-watch' onClick={() => openWindow(linkRadioCosmoWatch, newPageResized)} >
                    <p>GUARDA RADIOCOSMO</p>
                </div>
            </div>
            <div className='legge-trasparenza-container'>
                <div id='legge-trasparenza' onClick={() => navigate('/trasparenza')}>
                    <p>LEGGE SULLA TRASPARENZA 124/2017</p>
                </div>
            </div>
        </div>
    )
}

export default Aside;